import axios from "axios";
import {
    GET_COST_CENTERS,
    CHILD_COST_CENTERS,
    PARENT_COST_CENTERS,
    COST_CENTERS,
    SET_ERROR,
    CHILD_COST_CENTERS_MULTI,
    COST_CENTER_LEVELS
} from "../../types"

export const getCostCenterParents = (company) => {
    return async (dispatch) => {
        await axios.get(`api/cost-centers/cost-center-parents/${company}`).then(response => {

            dispatch({
                type: PARENT_COST_CENTERS,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            })
        })
    }
};

export const getChildCostCenters = (company, parentId) => {
    return async dispatch => {
        try {
            let costCenters = await axios.get(`api/cost-centers/child-cost-centers/${company}/${parentId}`);
            return dispatch({
                type: CHILD_COST_CENTERS,
                payload: costCenters.data
            })
        } catch (e) {
            return dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        };
    };
};

/**
 * 
 * @param {Object} params {companyShortName, treeIndex, levelQuery}
 * @param {Object|String} params.levelQuery either a straight level number or a query object with $gt, $lt, etc.
 * @returns 
 */
export const getChildCCByTreeIndex = params => {
    return async dispatch => {
        await axios.get('api/cost-centers/child-cc-by-tree-index', { params }).then(res => {
            dispatch({
                type: CHILD_COST_CENTERS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const getChildCCByTreeIndexMultiple = params => {
    return async dispatch => {
        await axios.get('api/cost-centers/child-cc-by-tidx-multiple').then(res => {
            dispatch({
                type: CHILD_COST_CENTERS_MULTI,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

/**
 * 
 * @param {String} company company _id
 * @returns 
 */
export const getCostCenterByCompany = company => {
    return async dispatch => {
        try {
            let costCenters = await axios.get(`api/cost-centers/cost-centers-by-company/${company}`);
            dispatch({
                type: COST_CENTERS,
                payload: costCenters.data
            });
        } catch (e) {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        };
    };
};

export const getCostCenterByTreeIndex = (index, clientId) => {
    return async (dispatch) => {
        await axios.get(`api/cost-centers/get-cost-center-api/${index}/${clientId}`)
            .then(response => {
                dispatch({
                    type: GET_COST_CENTERS,
                    payload: response.data,
                });
            });
    };
};

export const getCostCenterLevels = (companyShortName, treeIndex) => {
    return async (dispatch) => {
        await axios.get(`api/cost-centers/cc-levels/${companyShortName}/${treeIndex}`)
            .then(response => {
                dispatch({
                    type: COST_CENTER_LEVELS,
                    payload: response.data,
                });
            });
    };
}


export const clearCostCenters = () => ({ type: GET_COST_CENTERS, payload: "" });